import {memo} from 'react';
import {Card, CardBody, Typography} from "@material-tailwind/react";
import TitleWithInfoTooltip from "./TitleWithInfoTooltip";

interface DashboardCardProps {
    name: string,
    count: string
    icon: JSX.Element,
    color: string,
    tooltip?: string,
}
const DashboardCard = ({name, color, count, icon, tooltip}: DashboardCardProps) => {
    return (
        <Card className="bg-white dark:bg-blue-gray-900 dark:text-gray-500 mb-4 md:mb-0">
            <CardBody className="p-4 md:p-6">
                <Typography variant="h6" className={`mb-2 text-sm md:text-base text-right ${color.length>0 ? color : 'text-orange-400'}`}>
                    {icon}
                    <TitleWithInfoTooltip
                        title={name}
                        tooltip={tooltip}
                        className="flex flex-1 justify-end text-right"
                        tooltipPlacement="top"
                    />
                </Typography>
                <div className="text-right text-sm font-bold">{count}</div>
            </CardBody>
        </Card>
    );
}

export default memo(DashboardCard);
